export default __webpack_public_path__ + "static/media/sshart.cd7a4e11.png";